import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import * as runtime from '@/api/runtime'
import {
  BatchReminderPostcardPageLoadResult,
  BatchReminderPostcardPageLoadResultFromJSON
} from '@/api/models/batch/BatchReminderPostcardPageLoadResult'
import {
  BatchReminderPostcardRequest,
  BatchReminderPostcardRequestToJSON
} from '@/api/models/batch/BatchReminderPostcardRequest'

export class BatchReminderPostcardApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchReminderPostcardPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchReminderPostcardPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createReminderList(
    request: BatchReminderPostcardRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/reminder/postcard`,
      BatchReminderPostcardRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
